import { cdnHost, SEND_INQUIRY_ANIMATION_TIME } from '../../config';
import { getProductPictureUrl } from './Product';

let status = null;
let promise = null;

const FPS = 60;

const propMap = {
  width: 'px',
  height: 'px',
  top: 'px',
  bottom: 'px',
  left: 'px',
  minHeight: 'px',
  right: 'px',
  opacity: '',
  padding: 'px',
  paddingLeft: 'px',
  paddingRight: 'px',
  marginTop: 'px',
  fontSize: 'px'
};

const loadScript = (url) =>
  new Promise((resolve, reject) => {
    const scripts = document.getElementsByTagName('script');
    const scriptTag = document.createElement('script');
    const lastScriptTag = scripts[scripts.length - 1];
    scriptTag.type = 'text/javascript';
    scriptTag.src = url;
    scriptTag.onload = resolve;
    if ('onerror' in scriptTag) {
      scriptTag.onerror = reject;
    }
    if (
      lastScriptTag &&
      lastScriptTag.parentNode &&
      typeof lastScriptTag.parentNode.insertBefore === 'function'
    ) {
      lastScriptTag.parentNode.insertBefore(scriptTag, lastScriptTag);
    }
  });

export const load = () => {
  if (status === 'loaded') {
    return new Promise((resolve) => resolve());
  }

  if (status === 'loading') {
    return promise;
  }

  status = 'loading';
  promise = new Promise((resolve) => {
    Promise.all([
      loadScript(`${cdnHost}assets/TweenLite.min.js`),
      loadScript(`${cdnHost}assets/EasePack.min.js`),
      loadScript(`${cdnHost}assets/CSSPlugin.min.js`),
      loadScript(`${cdnHost}assets/BezierPlugin.min.js`)
    ])
      .then(() => {
        status = 'loaded';
        promise = null;

        resolve();
      })
      .catch(() => {
        status = null;
        promise = null;

        return resolve();
      });
  });

  return promise;
};

export const animate = (element, time, params, callback = () => {}) => {
  if (!element) {
    callback();
    return;
  }

  if ('TweenLite' in window) {
    setTimeout(callback, time * 1000);
    TweenLite.to(element, time, params);
    return;
  }

  window.requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    ((f) => setTimeout(f, 1000 / FPS));

  const initialStyle = window.getComputedStyle(element);

  const frames = FPS * time;

  params = Object.keys(params).map((prop) => {
    let initial = 0;
    if (initialStyle[prop]) {
      if (propMap[prop] === 'px') {
        initial = parseInt(initialStyle[prop].substr(0, initialStyle[prop].lastIndexOf('px')), 10);
      } else {
        initial = parseInt(initialStyle[prop], 10);
      }
    }

    return {
      prop,
      initial,
      final: params[prop],
      diff: (params[prop] - initial) / frames
    };
  });

  let step = 0;
  function animateRAF () {
    step += 1;

    params.forEach((param) => {
      let final = param.initial + step * param.diff;
      if (
        (param.final > param.initial && final > param.final) ||
        (param.final < param.initial && final < param.final)
      ) {
        final = param.final;
      }
      element.style[param.prop] = final + propMap[param.prop];
    });

    if (step <= frames) {
      window.requestAnimationFrame(() => {
        animateRAF();
      });
    } else {
      callback();
    }
  }

  window.requestAnimationFrame(() => {
    animateRAF();
  });
};

export const animateAsync = (element, time, params) =>
  new Promise((resolve) => {
    animate(element, time, params, resolve);
  });

export const animateAddToListClick = ({
  product,
  productImage,
  pictureUrl,
  callback,
  animateVertically
}) => {
  if (!productImage) {
    return;
  }

  const orderBar = document.querySelector('.order-bar');

  if (!orderBar) {
    return;
  }

  const imageRect = productImage.getBoundingClientRect();
  const orderBarRect = orderBar.getBoundingClientRect();

  let el = document.createElement('img');

  el.src = pictureUrl || getProductPictureUrl(product);

  document.querySelector('body').appendChild(el);

  const initialWidth = imageRect.width;
  const initialHeight = imageRect.height;
  const initialX = imageRect.x;
  const initialY = imageRect.y;

  let finalWidth;
  let finalHeight;
  if (initialWidth > initialHeight) {
    finalWidth = 50;
    finalHeight = (finalWidth * initialHeight) / initialWidth;
  } else {
    finalHeight = 30;
    finalWidth = (finalHeight * initialWidth) / initialHeight;
  }
  const finalX = orderBarRect.x + orderBarRect.width / 2 - finalWidth / 2;
  const finalY = orderBarRect.y + orderBarRect.height / 2 - finalHeight / 2;

  el.style.position = 'fixed';
  el.style.zIndex = 9999;
  el.style.width = `${imageRect.width}px`;
  el.style.height = `${imageRect.height}px`;
  el.style.borderRadius = '5px';

  el.style.left = initialX + 'px';
  el.style.top = initialY + 'px';

  TweenLite.to(el, SEND_INQUIRY_ANIMATION_TIME / 1000, {
    bezier: {
      type: 'soft',
      curviness: 1,
      values: [
        {
          opacity: 1,
          left: initialX,
          top: initialY,
          width: initialWidth,
          height: initialHeight
        },
        {
          opacity: 1,
          left: initialX + (animateVertically ? 0 : (finalX - initialX) / 2),
          top: initialY + (finalY - initialY) / 2,
          width: initialWidth + (finalWidth - initialWidth) / 2,
          height: initialHeight + (finalHeight - initialHeight) / 2
        },
        {
          opacity: 0,
          left: animateVertically ? initialX : finalX,
          top: finalY,
          width: finalWidth,
          height: finalHeight
        }
      ]
    },
    ease: Quad.easeOut,
    onComplete: () => {
      document.querySelector('body').removeChild(el);
      el = null;
      if (callback) {
        callback();
      }
    }
  });
};
